import api from '../..'

const destroyCertificate = (id: string | number) => {
  return api.delete(`administration/external_course_certificate/${id}`)
}

export default destroyCertificate
